import { ICreateAtividadeObraUseCase } from "../../../presentation/useCases/create/create_atividade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateAtividadeObraUseCase
 */

export class CreateAtividadeObraUseCase implements ICreateAtividadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createAtividadeObra(
    idObra: number,
    atividade: string,
    idFuncionarioResponsavel: number | null,
    funcionarioResponsavel: string | null,
    preencherResponsavel: boolean,
    idFuncionarioCorresponsavel: number | null,
    funcionarioCorresponsavel: string | null,
    preencherCorresponsavel: boolean,
  ): Promise<void> {
    const computedIdFuncionarioResponsavel = preencherResponsavel
      ? null
      : idFuncionarioResponsavel;

    const computedFuncionarioResponsavel = preencherResponsavel
      ? funcionarioResponsavel
      : null;

    const computedIdFuncionarioCorresponsavel = preencherCorresponsavel
      ? null
      : idFuncionarioCorresponsavel;

    const computedFuncionarioCorresponsavel = preencherCorresponsavel
      ? funcionarioCorresponsavel
      : null;

    await this.repository.createAtividadeObra(
      idObra,
      atividade,
      computedIdFuncionarioResponsavel,
      computedFuncionarioResponsavel,
      computedIdFuncionarioCorresponsavel,
      computedFuncionarioCorresponsavel,
    );
  }
}
